import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Input, Radio, message, Row, Col } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../util/axiosConfig';

const AddEditRole: React.FC = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { id } = useParams<{ id?: string }>();
    const [, setRole] = useState<any[]>([]);
    const isEditMode = Boolean(id);

    useEffect(() => {
        if (isEditMode && id) {
            axios.get(`/roles/get-role/${id}`)
                .then(response => {
                    const fetchedRole = response?.data?.data;
                    fetchedRole.slug = fetchedRole.slug || null;
                    fetchedRole.serialNo = fetchedRole.serialNo || null;
                    fetchedRole.active = fetchedRole.active || false;
                    setRole(fetchedRole);

                    form.setFieldsValue({
                        name: fetchedRole.name,
                        status: fetchedRole.active ? 'Active' : 'Inactive',
                    });
                })
                .catch(error => {
                    message.error('Failed to fetch role details');
                });
        } else {
            form.setFieldsValue({
                status: 'Active',
            });
        }
    }, [id, isEditMode, form]);

    const handleSubmit = async (values: any) => {
        const payload = {
            id: isEditMode ? Number(id) : 0,
            name: values.name,
            slug: null,
            serialNo: 0,
            active: values.status === 'Active',
        };

        try {
            if (isEditMode) {
                const res = await axios.put(`/roles/update-roles`, payload);
                if(res.data.error){
                    message.error(res.data.error)
                }else{
                    message.success('Role updated successfully');
                }
            } else {
                const res = await axios.post('/roles/create-role', payload);
                if(res.data.error){
                    message.error(res.data.error)
                }else{
                    message.success('Role added successfully');
                }
            }
            navigate('/role-list');
        } catch (error) {
            message.error('Failed to save role');
        }
    };

    return (
        <Card bordered={false} title={isEditMode ? "Edit Role" : "Add Role"}>
            <Row>
                <Col span={12}>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item name="name" label="Role Name" rules={[{ required: true, message: 'Please enter the role name' }]}>
                            <Input placeholder="Enter role name" />
                        </Form.Item>

                        <Form.Item name="status" label="Status" rules={[{ required: true, message: 'Please select a status' }]}>
                            <Radio.Group>
                                <Radio value="Active">Active</Radio>
                                <Radio value="Inactive">Inactive</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {isEditMode ? 'Update Role' : 'Add Role'}
                            </Button>
                            <Button onClick={() => navigate('/role-list')} style={{ marginLeft: 8 }}>
                                Cancel
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Card>
    );
};

export default AddEditRole;
